var _img;
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function OnlineOpinionForm(_ref) {
  let {
    className,
    ...rest
  } = _ref;
  let onlineOpinionForm;
  const handleShowOnlineOpinion = () => {
    onlineOpinionForm.show();
  };
  const loadOnlineOpinionForm = () => {
    import('./resources/external/oo_engine.min').then(() => {
      if (global && global.OOo) {
        onlineOpinionForm = new global.OOo.Ocode({});
      }
    });
  };
  useEffect(() => {
    const deferPromise = global.windowLoadPromise || Promise.resolve(true);
    deferPromise.then(() => loadOnlineOpinionForm());
  });
  return /*#__PURE__*/_jsx("div", {
    className: clsx('pull-right atcui-feedback', className),
    ...rest,
    children: /*#__PURE__*/_jsxs("span", {
      onClick: handleShowOnlineOpinion,
      onKeyPress: handleShowOnlineOpinion,
      className: "text-link link-undecorated text-gray-base display-inline-block padding-vertical-3",
      role: "button",
      tabIndex: 0,
      children: [_img || (_img = /*#__PURE__*/_jsx("img", {
        src: "https://autotrader.com/cm-api/content/static/img/onlineopinion/24x24-hover.gif",
        alt: "",
        loading: "lazy",
        className: "margin-right-2",
        width: "24px",
        height: "24px"
      })), "Feedback"]
    })
  });
}
export default OnlineOpinionForm;